import React, { useEffect } from 'react';
import { Menu } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns, faSquarePlus, faGears, faArrowRightFromBracket, faList, faFileCirclePlus, faFile } from '@fortawesome/free-solid-svg-icons';

const Sidebar = ({ setActivePage, activePage }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname.replace('/', '') || '/';
    setActivePage(path);
  }, [location, setActivePage]);

  const handleLogout = () => {
    localStorage.removeItem('token');

    console.log('Logged out');

    navigate('/signIn');
  };

  const iconStyle = { fontSize: '20px', color: '#FFBF00'};

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[activePage]}
      style={{ paddingTop: 0 }}
      className='bg-themeColor1'
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1rem 0', color: 'white' }}>
        <Link to="/signIn">
          <img src='/user.png' alt="UserPlaceholder" style={{ width: '35px' }} />
        </Link>
      </div>
      
      <Menu.Item 
        key="dashboard"
        icon={<FontAwesomeIcon icon={faTableColumns} style={iconStyle} />}
        style={{ backgroundColor: activePage === 'dashboard' ? 'transparent' : '' }}
      >
        <Link to="/" style={{ color: activePage === 'dashboard' ? 'white' : '' }}>Dashboard</Link>
      </Menu.Item>

      <Menu.Item 
        key="ledger" 
        icon={<FontAwesomeIcon icon={faFile} style={iconStyle} />}
        style={{ backgroundColor: activePage === 'ledger' ? 'transparent' : '' }}
      >
        <Link to="/ledger" style={{ color: activePage === 'ledger' ? 'white' : '' }}>Ledger</Link>
      </Menu.Item>

      <Menu.Item 
        key="addLedger" 
        icon={<FontAwesomeIcon icon={faFileCirclePlus} style={iconStyle} />}
        style={{ backgroundColor: activePage === 'addLedger' ? 'transparent' : '' }}
      >
        <Link to="/addLedger" style={{ color: activePage === 'addLedger' ? 'white' : '' }}>Add To Ledger</Link>
      </Menu.Item>

      <Menu.Item 
        key="expenseList" 
        icon={<FontAwesomeIcon icon={faList} style={iconStyle} />}
        style={{ backgroundColor: activePage === 'expenseList' ? 'transparent' : '' }}
      >
        <Link to="/expenseList" style={{ color: activePage === 'expenseList' ? 'white' : '' }}>Expense List</Link>
      </Menu.Item>
      
      <Menu.Item 
        key="addExpense" 
        icon={<FontAwesomeIcon icon={faSquarePlus} style={iconStyle} />}
        style={{ backgroundColor: activePage === 'addExpense' ? 'transparent' : '' }}
      >
        <Link to="/addExpense" style={{ color: activePage === 'addExpense' ? 'white' : '' }}>Add Expense</Link>
      </Menu.Item>
      
      <Menu.Item 
        key="settings" 
        icon={<FontAwesomeIcon icon={faGears} style={iconStyle} />}
        style={{ backgroundColor: activePage === 'settings' ? 'transparent' : '' }}
      >
        <Link to="/settings" style={{ color: activePage === 'settings' ? 'white' : '' }}>Settings</Link>
      </Menu.Item>
    
      <Menu.Item 
        key="logout" 
        icon={<FontAwesomeIcon icon={faArrowRightFromBracket} style={iconStyle} />}
        onClick={handleLogout} 
        style={{ position: 'absolute', bottom: 0, left: 0 }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
};

Sidebar.propTypes = {
  setActivePage: PropTypes.func.isRequired,
  activePage: PropTypes.string.isRequired,
};

export default Sidebar;
